module.exports = __webpack_public_path__ + "img/option_four.868b419b.png";